<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="$route.path == '/Report/ShopAssets'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">ตัวแทนจำหน่าย:</label>
                  <select2 :style="'width: 100%;'" :class="'form-control m-select2'" :id="'reSaAgentCode'"
                    :name="'reSaAgentCode'" :select2-options="reSaAgentCodeOptions" v-model="reSaAgentCode"
                    ref="reSaAgentCode" @selectChange="OnChangeAgentCode"></select2>
                  <span class="form-text"></span>
                </div>
              </div>

              <div v-show="this.$root.canShow(['AGENT_REPORT', 'BR_REPORT'])"
                class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reSaShopTypeId'"
                    :name="'reSaShopTypeId'"
                    :select2-options="reSaShopTypeIdOptions"
                    multiple
                    v-model="reSaShopTypeId"
                  ></select2> -->
                  <treeselect v-model="reSaShopTypeId" :multiple="true" :options="reSaShopTypeIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div v-show="this.$root.canShow(['AGENT_REPORT'])" class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ร้านค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reSaShopName'"
                    :name="'reSaShopName'"
                    :select2-options="reSaShopNameOptions"
                    multiple
                    v-model="reSaShopName"
                  ></select2> -->
                  <treeselect
                    v-model="reSaShopName"
                    :multiple="true"
                    :load-options="LoadreSaShopNameOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    v-on:open="reLoadSaShopNameOptions"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="reSaShopName"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reSaProductTypeId'"
                    :name="'reSaProductTypeId'"
                    :select2-options="reSaProductTypeIdOptions"
                    multiple
                    v-model="reSaProductTypeId"
                  ></select2> -->
                  <treeselect v-model="reSaProductTypeId" :multiple="true" :options="reSaProductTypeIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reSaBrandId'"
                    :name="'reSaBrandId'"
                    :select2-options="reSaBrandIdOptions"
                    multiple
                    v-model="reSaBrandId"
                  ></select2> -->
                  <treeselect v-model="reSaBrandId" :multiple="true" :options="reSaBrandIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reSaAssetCode'"
                    :name="'reSaAssetCode'"
                    :select2-options="reSaAssetCodeOptions"
                    multiple
                    v-model="reSaAssetCode"
                  ></select2> -->
                  <treeselect v-model="reSaAssetCode" :multiple="true" :options="reSaAssetCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button type="reset" class="btn btn-secondary" @click="formReset">
                  ล้างค่าทั้งหมด
                </button>
              </div>

              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="ExportShopAssets($event)" type="submit">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="shopAssetTable" style="width:100%">
                <thead>
                  <tr>
                    <th class="all text-right" colspan="12">
                      ข้อมูล ณ วันที่ {{ reSbsDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">จำนวน</th>
                    <th class="all text-center">หน่วยนับ</th>
                  </tr>
                </thead>
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function () {
    var self = this;

    return {
      reSaIsInitial: true,
      reSbsDateReq: null,
      reSaAgentCode: null,
      reSaShopTypeId: [],
      reSaShopName: [],
      reSaProductTypeId: [],
      reSaAssetCode: [],
      reSaBrandId: [],
      reSaProductTypeIdOptions: [],
      // reSaProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaBrandIdOptions: [],
      // reSaBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaAssetCodeOptions: [],
      // reSaAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaShopTypeIdOptions: [],
      // reSaShopTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ShopType",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reSaAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaShopNameOptions: [],
      // reSaShopNameOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ShopQuery",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reSaAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function (params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function (data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function (params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function (data) {
          return data.text;
        },
        language: {
          noResults: function () {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function (e) {
      let self = this;

      self.reSaAgentCode = null;
      self.reSaShopTypeId = [];
      self.reSaShopName = [];
      self.reSaProductTypeId = [];
      self.reSaAssetCode = [];
      self.reSaBrandId = [];

      // $("#reSaAgentCode")
      // .val("")
      // .trigger("change");

      $("#reSaAgentCode")
        .empty()
        .trigger("change");

      $("#reSaShopTypeId")
        .val("")
        .trigger("change");

      $("#reSaShopName")
        .val("")
        .trigger("change");

      $("#reSaProductTypeId")
        .val("")
        .trigger("change");

      $("#reSaAssetCode")
        .val("")
        .trigger("change");

      $("#reSaBrandId")
        .val("")
        .trigger("change");

      self.initSelectedAgent();
      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function (e, innerText = null) {
      let self = this;
      console.log(innerText);

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reSaIsInitial = true;
      }
      else {
        if (!$(this.$refs.form).validate().form()) {
          return false;
        }
      }

      e.preventDefault();
      var table = $("#shopAssetTable").DataTable();
      table.draw();
    },
    initSelectedAgent: function (e) {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/Select2Agent",
        data: {
          search: null,
          page: 1,
          province_id: [],
          department: [],
          AgentCodes: [],
        },
      })
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            self.$refs.reSaAgentCode.setSelectedData({
              id: response.data.results[0].id,
              text: response.data.results[0].text,
            });
          }
          else {
            //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function (error) {
          //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          //Swal.fire("เกิดข้อผิดพลาด", "", "error");
        })
        .then(function () {
          // always executed
          KTApp.unblockPage();
        });
    },
    OnChangeAgentCode: function (id, text, data, ref) {
      //this.LoadreSaShopNameOptions();
    },
    LoadreSaProductTypeIdOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reSaProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreSaBrandIdOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reSaBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreSaAssetCodeOptions: function (e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reSaAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreSaShopTypeIdOptions: function (e) {
      var self = this;
      axios
        .get("/Api/Report/Select2ShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reSaShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreSaShopNameOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reSaShopNameOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Report/Select2ShopQuery", {
            params: {
              page: 1,
              agentCode: self.reSaAgentCode,
              all: true,
              search: searchQuery,
            },
          })
          .then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reSaShopNameOptions = [];
              data.forEach((element) => {
                self.reSaShopNameOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reSaShopNameOptions);
          });
      }
    },
    reLoadSaShopNameOptions: function(){
      this.$refs.reSaShopName.trigger.searchQuery = null;
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    ExportShopAssets: function (e) {
      e.preventDefault();
      let self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportShopAssets",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reSaIsInitial,
          AgentCode: self.reSaAgentCode,
          ShopTypeId: self.reSaShopTypeId,
          ShopName: self.reSaShopName,
          ProductTypeId: self.reSaProductTypeId,
          AssetCode: self.reSaAssetCode,
          BrandId: self.reSaBrandId,
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;

    self.LoadreSaProductTypeIdOptions();
    self.LoadreSaBrandIdOptions();
    self.LoadreSaAssetCodeOptions();
    self.LoadreSaShopTypeIdOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reSbsDateReq = moment().format("DD/MM/YYYY h:mm a");
    self.initSelectedAgent();

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#shopAssetTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/ShopAssets",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function (d) {
            let jsonSearch = {
              IsInitial: self.reSaIsInitial,
              AgentCode: self.reSaAgentCode,
              ShopTypeId: self.reSaShopTypeId,
              ShopName: self.reSaShopName,
              ProductTypeId: self.reSaProductTypeId,
              AssetCode: self.reSaAssetCode,
              BrandId: self.reSaBrandId,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[1, "desc"]],
        columns: [
          {
            data: "agentCode",
            className: "text-center",
            render: function (data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "agentCode", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "shopTypeName", className: "text-center" },
          { data: "shopCode", className: "text-center" },
          { data: "shopName", className: "text-center" },
          { data: "shopName2", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "assetCode", className: "text-center" },
          { data: "assetName", className: "text-center" },
          { data: "brandName", className: "text-center" },
          {
            data: "shopAssetAmount",
            className: "text-center",
            render: function (data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "salesUnit", className: "text-center" },
        ],
        drawCallback: function (settings) {
          self.reSaIsInitial = false;
          self.reSbsDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("preXhr.dt", function () {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function () {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        reSaAgentCode: "required",
      },
      messages: {
        reSaAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// App/Components/Report/ShopAssets.vue